import callApi from 'utils/api/callApi'
import { FP_ENDPOINTS } from 'apps/fleet-planner/config'
import { INewTruck } from 'apps/fleet-planner/schema/TruckSchema'
import * as Types from 'apps/fleet-planner/types'

interface ICreateTruckResponse {
  truck: Types.ITruck
}

/**
 * Creates new truck
 * @method POST
 * @param {INewTruck} truck - Truck object
 */
export const createNewTruck = (truck: INewTruck): Promise<ICreateTruckResponse> => {
  return callApi({
    endpoint: FP_ENDPOINTS.trucks,
    method: 'POST',
    body: truck,
  })
}

/**
 * Updates existing truck
 * @method PUT
 * @param {Partial<Types.ITruck>} truck - Changes
 */
export const updateTruck = (
  truckId: string,
  changes: Partial<Types.ITruck>
): Promise<ICreateTruckResponse> => {
  return callApi({
    endpoint: `${FP_ENDPOINTS.trucks}/${truckId}`,
    method: 'PUT',
    body: {
      ...changes,
    },
  })
}
